import { FeatureFlagName } from "../types/feature-flags/featureFlag";

export class FeatureDisabledError extends Error {
  public readonly featureName: FeatureFlagName;

  constructor(featureName: FeatureFlagName) {
    super(`The ${featureName} feature is disabled.`);
    this.name = "FeatureDisabledError";
    this.featureName = featureName;
  }
}
